import { SITE_RECAPTCHA_KEY } from '@/config/site'

export const captchaControl = {
  async getToken() {
    if (SITE_RECAPTCHA_KEY == null || SITE_RECAPTCHA_KEY.length === 0) {
      return
    }

    return await window.grecaptcha.execute(SITE_RECAPTCHA_KEY!, {
      action: 'submit',
    })
  },
}
